import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { ProjectRolesService } from 'projects/shared/src/lib/services/project-roles.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'user-group-roles-button-renderer',
  templateUrl: './user-group-roles-button-renderer.component.html',
  styleUrls: ['./user-group-roles-button-renderer.component.scss']
})
export class UserGroupRolesButtonRendererComponent implements ICellRendererAngularComp {

  params: any;
  icon_delete!: string;
  _db!:string;
  //_forTenantDb = this.tenantService.currentTenantDb != null;

  constructor(private projectRolesService: ProjectRolesService,
    private translate: TranslateService,
    private tenantService:TenantService,
    private oauthService: OAuthServiceService,
    private notificationService: NotificationService) { }

  refresh(params: ICellRendererParams): boolean {
    const dataParams = params.colDef?.cellRendererParams;
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    console.log("------> UserGroupRolesButtonRendererComponent: params = ", this.params)
    this.icon_delete = this.params.icon_delete || null;

    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin') {
             this._db = dbrole;
            }
          });
        }
      }
    });

    this.refresh(params);
  }

  deleteUserFromGroupRole() {
    const rowData = [this.params.node.data];
    //if(!this._forTenantDb){
      //this.deleteFromMaindb(rowData);
    //}
    //else{
      this.deleteFromTenantdb(rowData);
    //}     
  }

  deleteFromTenantdb(rowData: any[]) {
    console.log("------>user-group-roles-button-renderer: deleteFromTenantdb")
    console.log("rowData = ", rowData[0])
    let db:string = this.tenantService.currentTenantName;
   this.tenantService.deleteUserFromGroupRole(db, this.tenantService.projectId, rowData[0].roleId, rowData[0].userId).subscribe({
      next: () => {
        this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERREMOVEDFROMGROUPROLE"]}`);
        this.params.api.refreshInfiniteCache();
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERREMOVEDFROMGROUPROLEERROR"]}`)
    });
  }

  // deleteFromMaindb(rowData: any[]) {
  //   console.log("------>user-group-roles-button-renderer: deleteFromMaindb")
  //   this.projectRolesService.deleteUserFromGroupRole(rowData[0].projectId, rowData[0].roleId, rowData[0].userId).subscribe({
  //     next: () => {
  //       this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERREMOVEDFROMGROUPROLE"]}`);
  //       this.params.api.refreshInfiniteCache();
  //     },
  //     error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERREMOVEDFROMGROUPROLEERROR"]}`)
  //   });
  // }
}
